"use client";
import { useState, useRef, useEffect } from "react";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useGenerator } from "@/app/context/GeneratorContext";
import GemCost from "../generatorViewPort/gemCost";
import GifLengthToggleSet from "./gifLengthToggleSet";
import ResToggleSet from "./resToggleSet";

export default function AdvancedToggleSetGif({ translations }: { translations: any }) {
  const { state, setCustomPromptGif, setGifAspectRatio, setGifLength } = useGenerator();
  const [open, setOpen] = useState(0);
  const [currentGeneratorId, setCurrentGeneratorId] = useState("");
  const textAreaRef = useRef(null);

  const gemCost = 1975 * (state.gifLength || 1);

  const adjustHeight = () => {
    if (!textAreaRef.current) return;
    //@ts-ignore
    textAreaRef.current.style.height = "inherit";

    //@ts-ignore
    textAreaRef.current.style.height = `${Math.max(
      //@ts-ignore
      textAreaRef.current.scrollHeight,
      120,
    )}px`;

    if (state.customPromptGif) {
      //@ts-ignore
      textAreaRef.current.style.height = `${Math.max(
        //@ts-ignore
        textAreaRef.current.scrollHeight,
        110,
      )}px`;
    }
  };

  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  const handleTextAreaChange = (e: any) => {
    const newText = e.target.value;
    setCustomPromptGif(newText);
    //@ts-ignore
    textAreaRef.current.style.height = "auto";
    adjustHeight();
  };

  useEffect(() => {
    if (currentGeneratorId !== state.selectedGenerator._id) {
      setCurrentGeneratorId(state.selectedGenerator._id);
    }
    adjustHeight();
  }, [state.customPromptGif, state.selectedGenerator._id]);

  function Icon({ id, open }: { id: number; open: number }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    );
  }

  return (
    <div className="mb-4 sm:mb-0">
      <Accordion
        open={open === 1}
        icon={<Icon id={1} open={open} />}
        className="border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] pt-2 sm:rounded-bl-lg sm:rounded-br-lg"
      >
        <AccordionHeader
          onClick={() => handleOpen(1)}
          className={`border-b-0 px-5 pb-4 pt-2 text-sm text-white sm:px-2 md:px-4 ${
            open === 1 ? "text-white hover:!text-white" : ""
          }`}
        >
          {translations.advanced}
          <div className="ml-auto flex flex-row">
            <GemCost amount={gemCost} />
          </div>
        </AccordionHeader>
        <AccordionBody className="pb-2 pt-0 font-normal text-white">
          <div className="mx-2 my-2 md:mx-4 md:my-4">
            <textarea
              ref={textAreaRef}
              value={state.customPromptGif}
              onChange={handleTextAreaChange}
              placeholder={
                true
                  ? `${translations.placeHolderOne} \n\n${translations.example}:\nPurple hair, braided hairstyle, legs spread, missionary vaginal\n\n`
                  : translations.placeHolderTwo
              }
              className={`auto-height-textarea w-full rounded-md border-[0.5px] border-[#3C3C3C] bg-[#303237] px-4 py-2 text-[16px] focus:border-[#3C3C3C] focus:ring-0`}
              rows={1}
              style={{ overflow: "hidden", resize: "none" }}
              maxLength={1000}
            ></textarea>
          </div>
          <div className="ml-2 md:ml-4">
            <ResToggleSet type="gif" translations={translations} />
            <GifLengthToggleSet translations={translations} />
          </div>
          <div className="my-4 mb-2 flex flex-col pl-[12px] sm:flex-row sm:space-x-2">
            <a
              href="https://www.createporn.com/blog/how-to-use-prompting-and-tags-more-effectively"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-auto text-sm font-medium text-[#6CB4F4]"
            >
              {translations.promptingGuide}
            </a>
          </div>
        </AccordionBody>
      </Accordion>
    </div>
  );
}
